// Service API centralisé.
//
// Objectif : piloter plusieurs marchés (site .fr / site .es) depuis un seul
// back-office. L'API attend la langue de deux façons :
//   - en LECTURE (GET)  : via le query param ?lang=<market>
//   - en ÉCRITURE (PUT/POST) : via le champ "language" dans le body JSON
//
// apiFetch() ajoute automatiquement le token d'auth et, sur les GET, le ?lang=.
// Pour les écritures, c'est à l'appelant de poser `body.language = getMarket()`
// avant de sérialiser (la forme du body varie d'un écran à l'autre).

// Domaines des différentes APIs (auparavant codés en dur dans chaque composant).
export const API = {
    back: 'https://back-api.therunningcollective.fr',
    products: 'https://back-products-api.therunningcollective.fr',
    legacyBack: 'https://backapi.therunningcollective.fr',
    legacyProducts: 'https://backapiproducts.therunningcollective.fr',
};

// Marchés pilotables. "fr" est le défaut et le fallback de l'API.
export const SUPPORTED_MARKETS = ['fr', 'es'];

export const MARKETS = {
    fr: { flag: '🇫🇷', label: 'France (.fr)' },
    es: { flag: '🇪🇸', label: 'Espagne (.es)' },
};

const MARKET_KEY = 'market';

export function getMarket() {
    const market = localStorage.getItem(MARKET_KEY);
    return SUPPORTED_MARKETS.includes(market) ? market : 'fr';
}

export function setMarket(market) {
    if (SUPPORTED_MARKETS.includes(market)) {
        localStorage.setItem(MARKET_KEY, market);
    }
}

// Identité de l'utilisateur connecté, telle qu'elle a été stockée à la
// connexion. Sert de REPLI pour les champs « modifié par » : côté API, c'est le
// sujet du JWT qui fait foi quand il est lisible (un client ne doit pas pouvoir
// signer une modification au nom de quelqu'un d'autre).
export function getUserLogin() {
    try {
        const user = JSON.parse(localStorage.getItem('token')) || {};
        return user.login || user.email || user.user || user.username || '';
    } catch (e) {
        return '';
    }
}

function getToken() {
    try {
        return JSON.parse(localStorage.getItem('token'))?.token;
    } catch (e) {
        return undefined;
    }
}

// Ajoute lang=<market> à une URL en préservant un éventuel query string existant.
export function withMarket(url, market = getMarket()) {
    const separator = url.includes('?') ? '&' : '?';
    return `${url}${separator}lang=${market}`;
}

// fetch() enrichi : injecte l'Authorization Bearer et, sur les GET, le ?lang=.
// Options supplémentaires :
//   - market: false  -> ne pas ajouter ?lang= (endpoint non internationalisé)
//   - market: 'fr'   -> forcer un marché précis
export function apiFetch(url, options = {}) {
    const { market, headers, ...rest } = options;
    const method = (rest.method || 'GET').toUpperCase();

    let finalUrl = url;
    if (method === 'GET' && market !== false) {
        finalUrl = withMarket(url, market || getMarket());
    }

    return fetch(finalUrl, {
        ...rest,
        headers: {
            Authorization: `Bearer ${getToken()}`,
            ...(headers || {}),
        },
    });
}
